module.exports = __webpack_public_path__ + "img/vo2-chart.ad7ae2dc.png";